export const NATIVE_APP_UA_TOKEN = "PraxisTarsNative";

const WEB_ONLY_PATHS = ["/landing", "/admin"] as const;
const APP_HOSTS = new Set(["praxistars.hu", "www.praxistars.hu"]);

export function isNativeApp() {
  if (typeof window === "undefined") {
    return false;
  }

  const capacitor = window.Capacitor;
  if (capacitor?.isNativePlatform?.()) {
    return true;
  }

  return navigator.userAgent.includes(NATIVE_APP_UA_TOKEN);
}

export function isNativeBlockedPath(pathname: string) {
  return WEB_ONLY_PATHS.some(
    (path) => pathname === path || pathname.startsWith(`${path}/`),
  );
}

export function nativeUrlToAppPath(rawUrl: string) {
  try {
    const url = new URL(rawUrl);
    let path: string;

    if (url.protocol === "praxistars:") {
      const route = [url.hostname, url.pathname]
        .filter(Boolean)
        .join("/")
        .replace(/^\/+/, "");
      path = `/${route}`;
    } else if (
      (url.protocol === "https:" || url.protocol === "http:") &&
      APP_HOSTS.has(url.hostname)
    ) {
      path = url.pathname;
    } else {
      return null;
    }

    if (isNativeBlockedPath(path)) {
      return "/";
    }

    return `${path || "/"}${url.search}${url.hash}`;
  } catch {
    return null;
  }
}

export function isExternalWebUrl(rawUrl: string) {
  try {
    const url = new URL(rawUrl, window.location.href);
    return (
      (url.protocol === "https:" || url.protocol === "http:") &&
      !APP_HOSTS.has(url.hostname)
    );
  } catch {
    return false;
  }
}

declare global {
  interface Window {
    Capacitor?: {
      isNativePlatform?: () => boolean;
    };
  }
}
